export default __webpack_public_path__ + "static/wxcode-6b68274f7a672659ad5cdce89444b100.png";